import { capitalize } from '../../utils'

const BAD_TRANSLATION_WORDS: Record<string, string> = {
  Seniors: '12th graders',
  Senior: '12th grader',
  Advisory: 'student support class/ my class',
  Homeroom: 'student support class/ my class',
  'Field trip': 'educational trip',
  'Early release': 'school will end early',
  assignments: 'school work',
  "student's teacher": "child's teacher",
  struggling: 'difficulty with',
  detention: 'a consequence for not following the rules',
  crew: 'team',
  template: 'models',
  freshman: '9th grader',
  norms: 'rules',
  suspension: 'student is sent home because they were not following the rules',
  potluck: 'bring food to share with the class',
  guardian: "child's parent",
  advisor: "child's teacher",
  bully: 'being unkind to other children',
  sibling: 'brother or sister',
  Junior: '11th grader',
  Sophomore: '10th grader',
  'checking in': 'connecting with you',
  'circle time': 'group activity',
  Intervention: 'support/help',
  tough: 'difficult',
  readiness: 'skills for school',
  Bully: 'not acting in a kind way',
  'Time-out': 'break from',
  'Reach out': 'contact',
  referral: 'finding support',
  'Room for improvement': 'improve further',
  'going the extra mile': 'putting in effort',
  'same page': 'understanding each other',
  'low grade': 'needs improvement/slight',
  mindfulness: 'awareness/focus',
}

for (var key in BAD_TRANSLATION_WORDS) {
  BAD_TRANSLATION_WORDS[key.toLowerCase()] = BAD_TRANSLATION_WORDS[key].toLowerCase()
  BAD_TRANSLATION_WORDS[capitalize(key)] = capitalize(BAD_TRANSLATION_WORDS[key])
}
export default BAD_TRANSLATION_WORDS
